export default __webpack_public_path__ + "207c377aa93bb6d93051c5122cc243d8.webp";